"use strict";
// (C) 2007-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiContent = void 0;
var tslib_1 = require("tslib");
var KpiContent_1 = tslib_1.__importDefault(require("./KpiContent"));
exports.KpiContent = KpiContent_1.default;
//# sourceMappingURL=index.js.map